import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSwUpdate } from '../lib/swUpdate';

export default function UpdateBanner() {
  const activate = useSwUpdate(s => s.activate);
  if (!activate) return null;
  return (
    <div role="status" className="flex flex-wrap items-center justify-between gap-3 border-b border-primary/30 bg-accent px-4 py-2.5 text-sm text-accent-foreground">
      <span><b>Có bản mới của FinTrack.</b> Tải lại để dùng tính năng và bản sửa lỗi mới nhất.</span>
      <Button size="sm" onClick={activate}><RefreshCw size={14} aria-hidden /> Tải lại</Button>
    </div>
  );
}
